export default __webpack_public_path__ + "73d886e0b3235ca59cc9c8b9f06ee00e.png";